/**
 * Temporary wishlist stored in localStorage for guests.
 * Merged into Firestore after Sharetribe login + Firebase custom token sign-in.
 */

import { ANONYMOUS_WISHLIST_KEY } from '../../firebase/config';
import { buildAnonymousWishlistEntry } from './wishlistHelpers';

const readStore = () => {
  if (typeof window === 'undefined') {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(ANONYMOUS_WISHLIST_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeStore = items => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(ANONYMOUS_WISHLIST_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
};

export const getAnonymousWishlistItems = () => readStore();

export const getAnonymousWishlistIds = () =>
  readStore().map(item => item.listingId).filter(Boolean);

export const addAnonymousWishlistItem = listing => {
  const entry = buildAnonymousWishlistEntry(listing);
  if (!entry) {
    return false;
  }
  const items = readStore().filter(i => i.listingId !== entry.listingId);
  items.push(entry);
  writeStore(items);
  return true;
};

export const removeAnonymousWishlistItem = listingId => {
  const items = readStore().filter(i => i.listingId !== listingId);
  writeStore(items);
};

export const clearAnonymousWishlist = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(ANONYMOUS_WISHLIST_KEY);
  } catch {
    // ignore
  }
};
